<template>
  <div class="container">
    <span class="title is-3">{{ empresa.nombrec }}</span>
    <small class="title is-5"
      >{{ empresa.nit | textnumber() }}{{ empresa.nit | dverif() }}</small
    >
    <small class="subtitle is-7">{{ empresa.nombre }}</small>
    <hr />
    <div style="margin-top: 32px; margin-bottom: 32px">
      <button
        class="button is-medium is-light"
        @click="(editable = true), (create = true)"
      >
        <span class="icon is-small">
          <span class="material-icons">add_circle_outline</span>
        </span>
        <span>Crear Bodega</span>
      </button>
    </div>
    <div>
      <p class="title">Bodegas</p>
    </div>
    <div class="table-container" v-if="editable == false">
      <table class="table is-hoverable is-fullwidth">
        <thead>
          <tr>
            <th>Código</th>
            <th>Nombre</th>
            <th></th>
          </tr>
        </thead>
        <tbody v-for="(cellar, index) in cellars" :key="index">
          <tr>
            <th>{{ cellar.codigo }}</th>
            <td style="display: flex; justify-content: space-between">
              {{ cellar.descripcion }}
            </td>
            <td>
              <span
                class="icon has-text-info hand"
                @click="selectcellar(cellar)"
              >
                <i class="material-icons">edit</i>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <hr />
    <div class="columns" v-if="editable == true">
      <div class="column">
        <p class="title is-5">Código</p>
        <div>
          <input
            v-model="cellarcode"
            name="input-edit-code"
            id="input-edit-code"
            class="input is-medium"
            type="text"
            placeholder="Nuevo código"
          />
        </div>
      </div>
      <div class="column">
        <p class="title is-5">Nombre</p>
        <div>
          <input
            v-model="cellarname"
            class="input is-medium"
            type="text"
            placeholder="Nuevo nombre"
          />
        </div>
      </div>
    </div>
    <div class="columns" v-if="editable == true">
      <div class="column">
        <div class="buttons" style="margin-top: 16px">
          <button
            class="button is-medium is-info"
            v-if="create == true"
            v-on:click="createCellar()"
          >
            <span class="icon is-small">
              <span class="material-icons">save</span>
            </span>
            <span>Guardar</span>
          </button>
          <button
            class="button is-medium is-info"
            v-if="create == false"
            v-on:click="editCellar()"
          >
            <span class="icon is-small">
              <span class="material-icons">edit</span>
            </span>
            <span>Editar</span>
          </button>
          <button
            class="button is-medium"
            @click="
              (editable = false),
                (groupSelected = []),
                (create = false),
                getCellars()
            "
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
import functions from "@/helpers/functions";
export default {
  data() {
    return {
      cellars: [],
      cellarSelected: {},
      editable: false,
      create: false,
      cellarcode: "",
      cellarname: "",
    };
  },
  computed: {
    ...mapState(["empresa", "productos"]),
  },
  methods: {
    selectcellar(cellar) {
      this.editable = true;
      this.cellarSelected = cellar;
      this.cellarcode = cellar.codigo;
      this.cellarname = cellar.descripcion;
    },
    async editCellar() {
      try {
        this.cellars = [];
        let result;
        if (this.cellarname !== "" && this.cellarcode !== "") {
          result = await apiServices.post(`/editcellar`, {
            id: this.cellarSelected._id,
            name: this.cellarname,
            code: this.cellarcode,
          });
          if (result.data && result.data.message) {
            this.$store.dispatch("notify", {
              message: "El código ya se encuentra en la base de datos.",
              type: "is-danger",
            });
            this.getCellars();
          } else {
            this.getCellars();
            this.editable = false;
            this.create = false;
            this.cellarcode = "";
            this.cellarname = "";
            this.$store.dispatch("notify", {
              message: "Perfecto!.  Bodega editada con éxito.",
            });
          }
        } else {
          this.$store.dispatch("notify", {
            message: "Llena todos los campos",
            type: "is-warning",
          });
          this.getCellars();
        }
      } catch (err) {
        console.log(err);
      }
    },
    async createCellar() {
      try {
        const data = {
          codigo: this.cellarcode,
          descripcion: this.cellarname,
        };
        let result;
        if (this.cellarname !== "" && this.cellarcode !== "") {
          result = await apiServices.post(`/createcellar`, data);
          console.log("result", result);
          if (result.data && result.data.message) {
            this.$store.dispatch("notify", {
              message: "El código ya se encuentra en la base de datos.",
              type: "is-danger",
            });
            this.getCellars();
          } else {
            this.getCellars();
            this.editable = false;
            this.create = false;
            this.cellarname = "";
            this.cellarcode = "";
            this.$store.dispatch("notify", {
              message: "Perfecto!. Bodega creada con éxito.",
            });
          }
        } else {
          this.$store.dispatch("notify", {
            message: "Llena todos los campos",
            type: "is-warning",
          });
          this.getCellars();
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getCellars() {
      try {
        this.cellars = [];
        const result = await apiServices.get(`/bodegas`);
        this.cellars = functions.order(result.data, "codigo");
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.getCellars();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/configurations/cellar/Cellar.vue